import React, { useState, useRef, useCallback } from "react";
import FolkType from "./FolkType";
import WitnessStatement from "./WitnessStatement";
import Arguments from "./Arguments";
import Evidence from "./Evidence";
import Solutions from "./Solutions";

import styles from "./Casefile.module.scss";
import { useEffect } from "react";

function Casefile(props) {
  const selected = props.selected;
  const setShowComment = props.setShowComment;
  const setSelected = props.setSelected;
  const [selectedForm, setSelectedForm] = React.useState({ form: "" });
  const setReport = props.setReport;
  const [evidence, setEvidence] = React.useState({
    link1: "",
    link2: "",
    link3: "",
    link1description: "",
    link2description: "",
    link3description: "",
    vid1: "",
    vid2: "",
    vid3: "",
    photo1: "",
    photo2: "",
    photo3: "",
    done: false,
  });
  const [args, setArgs] = React.useState({
    problem: "",
    feeling: "",
    argument: "",

    done: false,
  });
  const [statement, setStatement] = React.useState({
    incidenttype: "",
    allegation: "",
    affected: "",

    done: false,
  });
  const [solutions, setSolutions] = React.useState({
    solution: "",
    solutiondefense: "",

    done: false,
  });
  const [info, setInfo] = React.useState({
    nonhumantype: "",
    done: false,
  });
  const currentMarker = props.currentMarker;
  const handleSubmitReport = (
    evidence,
    args,
    statement,
    solutions,
    info,
    selected
  ) => {
    if (selected === undefined) {
      // console.log(evidence, args, statement, solutions, info, "handlingreport"),
      setReport({
        lat: currentMarker.lat,
        lng: currentMarker.lng,
        time: currentMarker.time,
        folk: props.type,
        nonhumantype: info.nonhumantype,
        solution: solutions.solution,
        solutiondefense: solutions.solutiondefense,
        incidenttype: statement.incidenttype,
        allegation: statement.allegation,
        affected: statement.affected,
        problem: args.problem,
        feeling: args.feeling,
        argument: args.argument,
        link1: evidence.link1,
        link2: evidence.link2,
        link3: evidence.link3,
        link1description: evidence.link1description,
        link2description: evidence.link2description,
        link3description: evidence.link3description,
        vid1: evidence.vid1,
        vid2: evidence.vid2,
        vid3: evidence.vid3,
        photo1: evidence.photo1,
        photo2: evidence.photo2,
        photo3: evidence.photo3,
        done: true,
        post: true,
        url:
          "https://cdn.shopify.com/s/files/1/0006/6060/2935/products/gotolgeggg_1024x1024@2x.jpg?v=1540409417",
        moderated: false,
        points: 0,
      });

      setSelectedForm({ form: "" });
    }
  };
  return (
    <div className={styles.queryBox}>
      <button
        className={styles.close}
        onClick={(event) => {
          setShowComment(false);
          setSelected(null);
        }}
      >
        x
      </button>
      <br />

      {selected && selected.points && <p>Points: {selected.points}</p>}
      <ul className={styles.navigation}>
        <li
          onClick={(e) => {
            setSelectedForm({ form: "info" });
          }}
        >
          {selected !== undefined && selected.folk !== ""
            ? "🌟"
            : info.done
            ? "✔️"
            : "⭕"}
          Information
        </li>

        <li onClick={(e) => setSelectedForm({ form: "statement" })}>
          {(selected !== undefined && selected.allegation !== "") || undefined
            ? "🌟"
            : statement.done
            ? "✔️"
            : "⭕"}{" "}
          Witness Statement
        </li>

        <li onClick={(e) => setSelectedForm({ form: "args" })}>
          {(selected !== undefined && selected.argument !== "") || undefined
            ? "🌟"
            : args.done
            ? "✔️"
            : "⭕"}{" "}
          Arguments
        </li>

        <li onClick={(e) => setSelectedForm({ form: "solutions" })}>
          {(selected !== undefined && selected.solution !== "") || undefined
            ? "🌟"
            : solutions.done
            ? "✔️"
            : "⭕"}{" "}
          Solutions
        </li>

        <li onClick={(e) => setSelectedForm({ form: "evidence" })}>
          {selected !== undefined &&
          (selected.link1 !== "" ||
            selected.vid1 !== "" ||
            selected.photo1 !== "")
            ? "🌟"
            : evidence.done
            ? "✔️"
            : "⭕"}
          Evidence
        </li>
      </ul>
      <ul>
        {selectedForm.form === "info" &&
        (selected === undefined || selected.type === "") ? (
          <li>
            <FolkType
              folk={props.type}
              setInfo={setInfo}
              setSelectedForm={setSelectedForm}
            />
          </li>
        ) : selectedForm.form === "info" && selected.type !== "" ? (
          <li>
            <p>This marker was left by one of the {selected.folk} folk.</p>
            <p>This report was made by a {selected.nonhumantype}</p>
          </li>
        ) : (
          <></>
        )}
        {selectedForm.form === "statement" &&
        (selected === undefined || selected.allegation === "") ? (
          <li>
            <WitnessStatement
              setStatement={setStatement}
              setSelectedForm={setSelectedForm}
            />
          </li>
        ) : selectedForm.form === "statement" && selected.allegation !== "" ? (
          <li>
            <p>What took place here was a {selected.incidenttype} incident</p>
            <b>In your own words, please describe the incident?</b>
            <p>{selected.allegation}</p>
            <b>Who is affected by this incident?</b>
            <p>{selected.affected}</p>
          </li>
        ) : null}
        {selectedForm.form === "args" &&
        (selected === undefined || selected.argument === "") ? (
          <li>
            <Arguments setArgs={setArgs} setSelectedForm={setSelectedForm} />
          </li>
        ) : selectedForm.form === "args" &&
          (selected === undefined || selected.argument !== "") ? (
          <li>
            <b>Why was this incident a problem?</b>
            <p>{selected.problem}</p>+<b>How did it make you feel?</b>
            <p>{selected.feeling}</p>
            <b>
              What would you say to convince humans that this problem does
              matter?
            </b>
            <p>{selected.argument}</p>
          </li>
        ) : null}
        {selectedForm.form === "solutions" &&
        (selected === undefined || selected.solution === "") ? (
          <li>
            <Solutions
              setSolutions={setSolutions}
              setSelectedForm={setSelectedForm}
            />
          </li>
        ) : selectedForm.form === "solutions" && selected.solution !== "" ? (
          <li>
            <b>Proposed Solution:</b>
            <p> {selected.solution}</p>
            <b>
              Imagine how humans might try to argue against your solution. How
              would you defend it?
            </b>
            <p>{selected.solutiondefense}</p>
          </li>
        ) : null}
        {selectedForm.form === "evidence" &&
        (selected === undefined ||
          (selected.link1 === "" &&
            selected.vid1 === "" &&
            selected.photo1 === "")) ? (
          <li>
            <Evidence
              setEvidence={setEvidence}
              setSelectedForm={setSelectedForm}
            />
          </li>
        ) : selectedForm.form === "evidence" &&
          (selected.link1 !== "" ||
            selected.vid1 !== "" ||
            selected.photo1 !== "") ? (
          <li>
            <b>Links</b>
            <br />
            <a href={selected.link1}>{selected.link1description}</a>
            <br />
            <a href={selected.link2}>{selected.link2description}</a>
            <br />
            <a href={selected.link3}>{selected.link3description}</a>
            <br />
            <b>Images</b>
            <br />
            <img src={selected.photo1} />
            <br />
            <img src={selected.photo2} />
            <br />
            <img src={selected.photo3} />
            <br />
            <b>Video</b>
            <br />
            <a href={selected.link3}>video</a>
            <br />
            <a href={selected.link3}>video</a>
            <br />
            <a href={selected.link3}>video</a>
            <br />
          </li>
        ) : null}
      </ul>

      {args.done && statement.done && solutions.done && info.done ? (
        <button
          onClick={(e) => {
            handleSubmitReport(evidence, args, statement, solutions, info);
          }}
        >
          Submit Full Report
        </button>
      ) : // (selected === undefined && evidence.done) ||
      //   args.done ||
      //   statement.done ||
      //   solutions.done ||
      //   info.done ? (
      //   <button
      //     onClick={(e) => {
      //       handleSubmitReport(evidence, args, statement, solutions, info);
      //     }}
      //   >
      //     Submit Partial Report
      //   </button>
      // ) :  evidence.done ||
      //   args.done ||
      //   statement.done ||
      //   solutions.done ||evidence.done &&
      //   info.done ? (
      //   <button
      //     onClick={(e) => {
      //       handleSubmitReport(
      //         evidence,
      //         args,
      //         statement,
      //         solutions,
      //         info,
      //         selected
      //       );
      //     }}
      //   >
      //     Submit Partial Report
      //   </button>
      null}
    </div>
  );
}

export default Casefile;

// function submitMarker(data) {
//   const { register, handleSubmit } = useForm;
//   const handleClick = () => {
//     setShowComment(false);
//   };
//   console.log(currentMarker);
//   console.log(data);
//   console.log("adding to database");
//   setShowComment(false);
//   db.collection("markers")
//     .add({
//       lat: currentMarker.lat,
//       lng: currentMarker.lng,
// time: currentMarker.time,
// folk: props.folk,
// nonhumantype: data.nonhumantype,
// solution: data.solution,
// solutiondefense: data.solutiondefense,
// incidenttype: data.incidenttype,
// allegation: data.allegation,
// affected: data.affected,
// problem: data.problem,
// feeling: data.feeling,marker
// argument: data.argument,
// link1: data.link1,
// link2: data.link2,
// link3: data.link3,
// link1description: data.link1description,
// link2description: data.link2description,
// link3description: data.link3description,
// vid1: data.vid1,
// vid2: data.vid2,
// vid3: data.vid3,
// url: currentIcon.url,
//       //       image: data.file[0],
//     })
//     .then(function (docRef) {
//       const imageRef = console.log("Document written with ID: ", docRef.id);

//       setMarkers((current) => [
//         ...current,
//         {
//           lat: currentMarker.lat,
//           lng: currentMarker.lng,
//           time: currentMarker.time,
//           folk: props.folk,
//           nonhumantype: data.nonhumantype,
//           solution: data.solution,
//           solutiondefense: data.solutiondefense,
//           incidenttype: data.incidenttype,
//           allegation: data.allegation,
//           affected: data.affected,
//           problem: data.problem,
//           feeling: data.feeling,
//           argument: data.argument,
//           link1: data.link1,
//           link2: data.link2,
//           link3: data.link3,
//           link1description: data.link1description,
//           link2description: data.link2description,
//           link3description: data.link3description,
//           vid1: data.vid1,
//           vid2: data.vid2,
//           vid3: data.vid3,
//           url: currentIcon.url,
//         },
//       ]);
//     })
//     .catch(function (error) {
//       console.error("Error adding document: ", error);
//     });
// }
